import { render, staticRenderFns } from "./CelebShort.vue?vue&type=template&id=4f5804ca&"
import script from "./CelebShort.vue?vue&type=script&lang=js&"
export * from "./CelebShort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports